<script setup lang="ts">
const privacyPolicy = ref("");
const { $i18n } = useNuxtApp();

onMounted(() => {
  fetch(`/api/policies/PrivacyPolicy?locale=${$i18n.locale.value}`)
    .then((response) => response.text())
    .then((data) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = String(data ?? "");
      const styleTags = tempDiv.getElementsByTagName("style");
      Array.from(styleTags).forEach((style) => {
        let cssText = style.innerHTML;
        cssText = cssText.replace(/([^{}]*){/g, ".privacy-container $1{");
        style.innerHTML = cssText;
      });

      privacyPolicy.value = tempDiv.innerHTML;
    });
});

// Steps for preparing html doc:
// Ensure line-height is set to 2 everywhere
// anchor tags should have target="_blank" and cleanup the hrefs (remove google redirect and &amp;)
</script>

<template>
  <h1 class="text-5xl font-bold tracking-tight text-neutral-200 mb-10">
    {{ $t("main.pageLegal.privacyPolicy") }}
  </h1>
  <div class="privacy-container" v-html="privacyPolicy"></div>
</template>
